module.exports = __webpack_public_path__ + "static/img/footer-img.0374c8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer-img.png
// module id = F6q4
// module chunks = 7